import { makeStyles } from '@material-ui/core';
import { green, neutral } from '../../../../shared/styles/colors';
import type { TurboTagProps } from './TurboTag';
import { turboTagTextSize } from './turbo-tag.const';

export default makeStyles({
  container: ({ variant }: TurboTagProps) => ({
    background: green.D7,
    borderRadius: '0.5rem',
    padding: `${variant === 'header' ? '0' : '0.125rem'} 0.625rem`,
    '@media (width >= 768px)': {
      padding: '0.125rem 0.625rem',
    },
  }),
  text: ({ variant }: TurboTagProps) => ({
    color: neutral.white,
    fontWeight: 600,
    fontSize: turboTagTextSize[variant].small,
    lineHeight: '1rem',
    '@media (width >= 768px)': {
      fontSize: turboTagTextSize[variant].default,
    },
  }),
});
